import React, { memo } from 'react';
import styled from '@emotion/styled';

import ArrowIcon from '~/Assets/icons/arrow_forward.svg';
import { useButton, useCurrency } from '~Hooks';

const Header = styled.div`
  letter-spacing: 0.24px;
  font-size: 16px;
  min-height: 65px;
  border-bottom: 1px solid var(--colorBlueGray1100);
  color: #fff;
  padding: 0 12px 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const ArrowIconDiv = styled.div<{ expanded: boolean }>`
  height: 24px;
  width: 24px;
  mask-image: url(${ArrowIcon});
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: ${({ expanded }) =>
    expanded ? 'var(--colorUISand)' : 'var(--colorBlueGray800)'};
  transform: ${({ expanded }) => (expanded ? 'rotate(90deg)' : 'rotate(270deg)')};
  transition: all 0.2s linear;
`;

const NoOfItems = styled.span`
  font-weight: 400;
`;

const TotalPrice = styled.div`
  display: flex;
  flex-flow: column nowrap;
  text-align: right;
  font-weight: 500;

  span:nth-of-type(2) {
    color: var(--colorBlueGray600);
    text-decoration: line-through;
    font-size: 12px;
  }
`;

interface Props {
  title: string;
  total: number;
  discount?: number;
  cartExpanded: boolean;
  onCartExpanded: () => void;
}

const CartHeader: React.FC<Props> = ({
  title,
  total,
  discount = 0,
  cartExpanded,
  onCartExpanded,
}) => {
  const currency = useCurrency();

  const headerTouchHandlers = useButton({
    onClick: () => onCartExpanded(),
  });

  return (
    <Header {...headerTouchHandlers} data-testid="cart-header">
      <NoOfItems key={title}>{title}</NoOfItems>
      <ArrowIconDiv expanded={cartExpanded} />
      <TotalPrice>
        <span>{currency.format(total - discount)}</span>
        {discount > 0 && <span>{currency.format(total)}</span>}
      </TotalPrice>
    </Header>
  );
};

export default memo(CartHeader);
